import React from 'react';
import { Link } from '../link/Link.component';
import { HelpArticle } from '../../../hooks/useHelpPanel';
import { RouteConstants } from '../../../route-constants';
import { HelpBubble } from './HelpBubble.component';

interface MaterialHelpBubbleProps {
    /** Defaults to the overview article; pass a specific material where the context is narrower. */
    article?: HelpArticle;
    /** Hide the inline text link where space is tight (a compact table row, say). */
    showGuideLink?: boolean;
    className?: string;
}

/**
 * The "?" affordance placed next to every material picker in the portal.
 *
 * Two escapes on purpose: the bubble opens the material article in the Help
 * Panel drawer without leaving the current flow, and the link goes to the full
 * Material Guide page when the seller wants the side-by-side comparison, the
 * objection scripts, or a printable copy.
 */

// #region MaterialHelpBubble
export const MaterialHelpBubble: React.FunctionComponent<MaterialHelpBubbleProps> = (
    props: MaterialHelpBubbleProps
): React.ReactElement => {
    const { article = HelpArticle.MATERIALS_OVERVIEW, showGuideLink = true, className } = props;

    return (
        <span className={`inline-flex items-center gap-1 ${className ?? ''}`}>
            <HelpBubble article={article} />
            {showGuideLink && (
                <Link
                    href={RouteConstants.MATERIAL_GUIDE}
                    className="cursor-pointer text-xs text-emerald-600 underline dark:text-emerald-400"
                    title="Open the full Material Guide"
                >
                    View full Material Guide
                </Link>
            )}
        </span>
    );
};
